import { render, staticRenderFns } from "./extended.vue?vue&type=template&id=9a50c6ba&"
import script from "./extended.vue?vue&type=script&lang=js&"
export * from "./extended.vue?vue&type=script&lang=js&"
import style0 from "./extended.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports